import {
    SolicitudActionTypes,
    SET_SOLICITUD,
    SET_SOLICITUD_COPIA
} from "../types/solicitudActionType";
import {enums} from "../../enums/enums";
import {Solicitud} from "../../entities/solicitudes/Solicitud";

export const initialSolicitud = {
    id: 0,
    estatusId: enums.estatusSolicitud.proyecto,
    seccionId: enums.estatusSolicitud.proyecto,
    
    // seccionId: enums.estatusSolicitud.registroUsuario,
    completada: false,
    completadaMarkup: false,
    modificar:true,
    paisIdOrigen: 0,
    paisIdDestino: 0,
    esSeguroBasico: true,
    esSeguroMercancia: false,
    esFormaValida: true,
    camposRequeridos: [],
    camposInvalidos: [],
    costoSeguro:0,
    costoMarkup:0,
    claseId:0,
    clase:'',
    clienteReferencias: []
};

const nuevaSolicitud = new Solicitud(initialSolicitud);

export function solicitudReducer(state = nuevaSolicitud, action: SolicitudActionTypes): Solicitud {
    switch (action.type) {
        case SET_SOLICITUD:
            return action.solicitud;
        default:
            return state;
    }
}

export function solicitudCopiaReducer(state = nuevaSolicitud, action: SolicitudActionTypes): Solicitud {
    switch (action.type) {
        case SET_SOLICITUD_COPIA:
            return action.solicitud;
        default:
            return state;
    }
}
